import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface ConceptTagProps {
    conceptId: string;
    label: string;
    className?: string;
}

export default function ConceptTag({ conceptId, label, className }: ConceptTagProps) {
    const location = useLocation();

    return (
        <Link
            to={`/concepts/${conceptId}`}
            state={{ from: location.pathname }}
            className={cn(
                "tag-pill group flex items-center gap-1.5 py-1 px-3 bg-game-surface-3/50 backdrop-blur-sm hover:border-game-primary-l/40 transition-all",
                className
            )}
        >
            <span className="text-game-primary group-hover:scale-125 transition-transform duration-300">📌</span>
            <span className="uppercase tracking-[0.05em] font-black">{label}</span>
        </Link>
    );
}
